module.exports = __webpack_public_path__ + "static/email/img/icon_view.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_view.png
// module id = nJCZ
// module chunks = 1